// <div data-controller="admin--llm--prompts">
//
// </div>
import { Controller } from "@hotwired/stimulus";
import api from "utils/api";
import pLimit from "p-limit";

// https://stimulus.hotwired.dev/reference
export default class extends Controller {
  static targets = [
    "systemPrompt",
    "userPrompt",
    "reduceTitle",
    "imageCountToInclude",
  ];
  static classes = [""];
  static outlets = ["admin--llm--article"];
  static values = {};

  initialize() {}

  async predictAll() {
    const limit = pLimit(3);

    const promises = this.adminLlmArticleOutlets.map(
      (adminLlmArticleOutlet) => {
        limit(() => adminLlmArticleOutlet.predict());
        limit(() => adminLlmArticleOutlet.predictGcp());
      }
    );

    const results = await Promise.all(promises);
    console.log("모든 예측이 완료되었습니다:", results);
  }

  connect() {}

  disconnect() {}
}
